var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7064 11.2932C15.8938 11.4807 15.9992 11.735 15.9992 12.0002C15.9992 12.2653 15.8938 12.5197 15.7064 12.7072L10.0494 18.3642C9.95712 18.4597 9.84678 18.5359 9.72477 18.5883C9.60277 18.6407 9.47155 18.6683 9.33877 18.6694C9.20599 18.6706 9.07431 18.6453 8.95141 18.595C8.82852 18.5447 8.71686 18.4705 8.62297 18.3766C8.52908 18.2827 8.45483 18.171 8.40454 18.0481C8.35426 17.9252 8.32896 17.7936 8.33012 17.6608C8.33127 17.528 8.35886 17.3968 8.41126 17.2748C8.46367 17.1528 8.53986 17.0424 8.63537 16.9502L13.5854 12.0002L8.63537 7.05018C8.45321 6.86158 8.35241 6.60898 8.35469 6.34678C8.35697 6.08458 8.46214 5.83377 8.64755 5.64836C8.83296 5.46295 9.08377 5.35778 9.34597 5.35551C9.60816 5.35323 9.86076 5.45402 10.0494 5.63618L15.7064 11.2932Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPRightArrow);
export default __webpack_public_path__ + "static/media/p_right_arrow.8bea2fe8f323686e6bca191308aa2f7d.svg";
export { ForwardRef as ReactComponent };